<template>
  <div :class="rowClasses">
    <v-progress-circular
      v-if="!isJobFinished"
      indeterminate
      color="#C2C2C2"
      :width="2"
      :size="16"
    />
    <v-icon
      v-if="isJobFinished"
      :class="visual[status].icon"
      v-html="visual[status].type"
    />
    <span :class="`${visual[status].text} ml-3`" v-html="process.text" />
  </div>
</template>

<script lang="js">
import {
  PROGRESS,
  ERRO,
  DONE
} from "@/components/Apolice/Steps/AutomaticApproval.js"

const visual = {
  [PROGRESS]: {
    icon: "",
    type: "check_circle",
    text: "text_default"
  },
  [DONE]: {
    icon: "icon_success",
    type: "check_circle",
    text: "text_success"
  },
  [ERRO]: {
    icon: "icon_error",
    type: "cancel",
    text: "text_error"
  }
};

export default {
  name: "ProcessListItem",
  props: ["process"],
  data() {
    return {
      visual
    };
  },
  computed: {
    rowClasses() {
      return {
        'px-3': true,
        'py-2': true,
        'job': true,
        'job-progress': this.isProgress,
        'job-done': this.isDone,
        'job-erro': this.isError
      };
    },
    status() {
      return this.process.status;
    },
    isJobFinished() {
      return this.process.status !== PROGRESS;
    },
    isProgress() {
      return this.process.status === PROGRESS;
    },
    isDone() {
      return this.process.status === DONE;
    },
    isError() {
      return this.process.status === ERRO;
    }
  }
};
</script>

<style lang="scss">
$red: #d21a5e;
$green: #7ed321;

.job {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;

  .v-icon {
    font-size: 18px !important;
  }

  &-done {
    .v-icon {
      color: $green;
    }
  }

  &-erro {
    .v-icon {
      color: $red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/ProcessListItem.vue